<div class="nav-item-container" [attr.isCollapsed]="isSideNavCollapsed ? '1' : '0'">
<!--   <mat-icon *ngIf="menu.icon && !menu.image" class="nav-item-icon">{{ menu.icon }}</mat-icon> -->
  <app-svg-icon *ngIf="menu.icon && !menu.image" class="nav-item-icon" [icon]="menu.icon"></app-svg-icon>
  <img *ngIf="menu.image" src="{{ menu.image }}" alt="" />
  <span class="nav-item-text p-l-15">{{ "SIDE_NAV_BAR." + menu.translationTextKey | translate }}</span>
</div>
